import React, { useState, useEffect, useContext } from "react";
import { HeaderHeading } from "../../../../Context";
import organisms from "../../../../components/organisms";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import { useToasts } from 'react-toast-notifications';
import constant from "../../../../constants/constant";
import service from "../../../../api/services";
import {handleReportDownload} from "../../../../constants/utils"
import { ExtendedQueryError, ReportStateProps } from "./interface";

const { EcomReport } = organisms

const Index = () => {
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const [reportData, setReportData] = useState<ReportStateProps>({
        report_format: NaN,
        created_from: null,
        created_to: null
    })
    const { addToast } = useToasts();

    const handleSubmit = async () => {
        try {
            const response = await service.reportService?.getEComReport({ created_from: reportData?.created_from, created_to: reportData?.created_to })
            if (response.status === 200) {
                handleReportDownload(response?.data?.data, "store-sales-invoice-wise-report", constant?.DailyReportFormat[1].value,"")
            }
        } catch (error) {
            console.error('error', error)
            const apiError = error as ExtendedQueryError
            addToast(apiError?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const handleChange = (name: string, e:string | number) => {
        setReportData({ ...reportData, [name]: e })
    }

    useEffect(() => {
        setHeader("Report - E-Com Orders Report")
    }, [])
    return (
        <Wrapper>
            <EcomReport
                handleChange={(name: string, value:string | number) => handleChange(name, value)}
                handleSubmit={() => handleSubmit()}
                reportData={reportData} />
        </Wrapper>
    )
}

export default Index